import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Row } from 'antd'
//
import global from 'common'

import Input from 'common/components/dataEntry/components/Input'
import Error from 'common/components/dataEntry/formik/FormItemError'
import Button from 'common/components/general/Button'

import './CreditCard.less'

interface CreditCardFormProps {
  recurlyErrors: Map<string, string>
  onSaveClick: () => void
  onCancel: () => void
  firstName: string
  lastName: string
}

const CreditCardForm: React.FC<CreditCardFormProps> = ({
  recurlyErrors,
  onSaveClick,
  onCancel,
  firstName,
  lastName,
}) => {
  const { t: translate } = useTranslation()
  const { isXs } = global.hooks.useBreakPoints()

  useEffect(() => {
    recurly.configure({
      style: {
        all: {
          height: '32px',
        },
        number: {
          placeholder: {
            content: 'XXXX XXXX XXXX XXXX',
          },
          style: {
            height: '32px',
          },
        },
        month: {
          placeholder: 'MM',
        },
        year: {
          placeholder: 'YYYY',
        },
        cvv: {
          placeholder: {
            content: 'XXX',
          },
        },
      },
    })
  }, [])

  return (
    <form autoComplete="off" id="recurly-form">
      <Row gutter={24} className="mt-16">
        <Col xs={24} sm={8} className="mb-24">
          <label className="formik-field__input-label">{translate('general.first-name')}</label>
          <Input type="text" data-recurly="first_name" className="ant-input" defaultValue={firstName} />
          {recurlyErrors.get('first_name') ? <Error>{recurlyErrors.get('first_name')}</Error> : null}
        </Col>

        <Col xs={24} sm={8} className="mb-24">
          <label className="formik-field__input-label">{translate('general.last-name')}</label>
          <Input
            type="text"
            data-recurly="last_name"
            defaultValue={lastName}
            className="ant-input input__no-autofill-color"
          />
          {recurlyErrors.get('last_name') ? <Error>{recurlyErrors.get('last_name')}</Error> : null}
        </Col>

        <Col xs={24} sm={8} className="mb-24">
          <div>
            <label className="formik-field__input-label">
              {translate('admin-signup.subscription.payment.card-number-label')}
            </label>
            <div data-recurly="number" className="container"></div>
          </div>
          {recurlyErrors.get('number') ? <Error>{recurlyErrors.get('number')}</Error> : null}
        </Col>

        <Col xs={24} sm={8} className="mb-24">
          <label className="formik-field__input-label">
            {translate('admin-signup.subscription.payment.expiration-month-label')}
          </label>
          <div data-recurly="month" className="container"></div>
          {recurlyErrors.get('month') ? <Error>{recurlyErrors.get('month')}</Error> : null}
        </Col>

        <Col xs={24} sm={8} className="mb-24">
          <label htmlFor="bankName" className="formik-field__input-label">
            {translate('admin-signup.subscription.payment.expiration-year-label')}
          </label>
          <div data-recurly="year" className="container"></div>
          {recurlyErrors.get('year') ? <Error>{recurlyErrors.get('year')}</Error> : null}
        </Col>

        <Col xs={24} sm={8} className="mb-24">
          <label className="formik-field__input-label">
            {translate('admin-signup.subscription.payment.cvv-label')}
          </label>
          <div data-recurly="cvv" className="container"></div>
          {recurlyErrors.get('cvv') ? <Error>{recurlyErrors.get('cvv')}</Error> : null}
        </Col>
      </Row>

      <Row gutter={24} className={`flex ${isXs ? 'mb-8' : 'justify-end mb-8'}`}>
        <Col className="align_self_end">
          <Button type="default" onClick={() => onCancel()} className="color-gray-8">
            {translate('general.cancel')}
          </Button>
        </Col>
        <Col className="align_self_end">
          <Button type="primary" onClick={() => onSaveClick()}>
            {translate('general.save')}
          </Button>
        </Col>
      </Row>
      {/* recurly complains if country is absent, even though it's set up for no address requirement */}
      <input type="hidden" name="recurly-country" data-recurly="country" value="US" />
      <input type="hidden" name="recurly-token" data-recurly="token" />
    </form>
  )
}

export default CreditCardForm
